import { useEffect } from "react";
import { clsx } from "clsx";

import { Small } from "@/shared/ui/Button/Button";
import { Title } from "@/shared/ui/Title";
import { useDevice } from "@/shared/lib/hooks/useDevice";
import { CHUNK_AUTO_REFRESH } from "@/shared/const/storageKeys";
import { isErrorLike } from "@/shared/lib/helpers/isErrorLike";

import cls from "./Error.module.scss";

interface ErrorProps {
  error?: Error;
}

export const Error = ({ error }: ErrorProps) => {
  const { isMobile } = useDevice();

  const isChunkError = isErrorLike(error) && /Loading (CSS )?chunk [\d]+ failed/i.test(error.message);

  useEffect(() => {
    if (!isChunkError) {
      return;
    }

    const hasRefreshed = sessionStorage.getItem(CHUNK_AUTO_REFRESH);

    if (isChunkError && !hasRefreshed) {
      sessionStorage.setItem(CHUNK_AUTO_REFRESH, "yes");

      window.location.reload();
    }
  }, [isChunkError]);

  const clickRefresh = () => {
    window.location.reload();
  };

  const clickRedirect = () => {
    window.location.href = "/support";
  };

  // prevent render error until after we've tried a refresh for chunk errors
  if (isChunkError && !sessionStorage.getItem(CHUNK_AUTO_REFRESH)) {
    return null;
  }

  return (
    <div className={clsx(cls.Error, { [cls.isMobile]: isMobile })}>
      <Title>Unexpected Error</Title>
      <div className={cls.Text}>
        <p>We really apologise, but something went wrong. You can try next actions below.</p>
      </div>
      <div className={cls.Buttons}>
        <Small onClick={clickRefresh}>Refresh Page</Small>
        <span>or</span>
        <Small onClick={clickRedirect}>Contact Support</Small>
      </div>
    </div>
  );
};
